// extracted by mini-css-extract-plugin
export default {"auto":"table-filter-root-responsive_auto__imw0j"};